import React, { useState, useEffect } from 'react';
import Popup from 'reactjs-popup';
import { FaEdit, FaPlus, FaTrash } from 'react-icons/fa';
import '../styles/pages/ModalLoan.css';  // Add your modal styles

function ModalLoan(props) {
  const [open, setOpen] = useState(false);  // Manage modal open/close
  const [content, setContent] = useState(props.value);  // Local state for content

  useEffect(() => {
    // Keep the content updated with props if it's passed new values
    setContent(props.value);
  }, [props.value]);

  // Toggle modal open/close
  const onClick = () => {
    setOpen(!open);
  };

  // Handle changes in the input fields
  const handleChange = (index, field, value) => {
    const updatedContent = [...content];
    updatedContent[index][field] = value;
    setContent(updatedContent);  // Update the content with new value
  };

  // Add new row when the user clicks the "+" button
  const addRow = () => {
    const newRow = { deposit_period: '', general_depositors: '', senior_citizens: '' };
    setContent([...content, newRow]);  // Add an empty row
  };

  // Delete row (with optional backend call)
  const handleDelete = async (index, id) => {
    if (id) {
      try {
        const response = await fetch(`/api/depositeInterest-rate/${id}`, {
          method: 'DELETE',
        });
        if (!response.ok) {
          throw new Error('Failed to delete from backend');
        }
      } catch (error) {
        console.error('Delete error:', error);
        alert('Failed to delete from server.');
        return;
      }
    }

    // Remove from UI
    const updatedContent = [...content];
    updatedContent.splice(index, 1);
    setContent(updatedContent);
  };

  // Handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();
    // Pass updated content back to parent component via onSubmit prop
    props.onSubmit(content);
    setOpen(false);  // Close modal after submitting
  };

  return (
    <div className="modalDiv">
      <FaEdit onClick={onClick} className="edit-icon" />

      {/* Popup modal */}
      <Popup className="editModal" open={open} closeOnDocumentClick={false}>
        <a className="close" onClick={onClick}>
          &times;
        </a>
        <p className="modal-title">Edit Interest Rates</p>

        <div className="modal-content" style={{ maxHeight: '55vh', overflowY: 'auto' }}>
          <form onSubmit={handleSubmit}>
            {/* Loop through the content and display input fields */}
            {content.map((item, index) => (
              <div key={index} className="modal-row">
                <div className="text-input-container">
                  <label htmlFor={`deposit_period-${index}`}>Deposit Period</label>
                  <input
                    id={`deposit_period-${index}`}
                    value={item.deposit_period}
                    onChange={(e) => handleChange(index, 'deposit_period', e.target.value)}
                  />
                </div>
                <div className="text-input-container">
                  <label htmlFor={`general_depositors-${index}`}>General Depositors</label>
                  <input
                    id={`general_depositors-${index}`}
                    value={item.general_depositors}
                    onChange={(e) => handleChange(index, 'general_depositors', e.target.value)}
                  />
                </div>
                <div className="text-input-container">
                  <label htmlFor={`senior_citizens-${index}`}>Senior Citizens</label>
                  <input
                    id={`senior_citizens-${index}`}
                    value={item.senior_citizens}
                    onChange={(e) => handleChange(index, 'senior_citizens', e.target.value)}
                  />
                </div>

                {/* Delete button */}
                <div className="delete-btn-container">
                  <FaTrash
                    className="delete-btn"
                    onClick={() => handleDelete(index, item._id)}
                    title="Delete Row"
                  />
                </div>
              </div>
            ))}

            {/* Button to add new row */}
            <div className="add-btn-container">
              <FaPlus onClick={addRow} className="add-btn" />
            </div>

            {/* Submit button */}
            <button type="submit" className="submit-btn">
              Submit
            </button>
          </form>
        </div>
      </Popup>
    </div>
  );
}

export default ModalLoan;
